<template>
  <item-v2-main></item-v2-main>
</template>

<script setup lang="ts">
import ItemV2Main from "@/components/itemV2/itemV2Main.vue";
</script>